const getDefaultState = () => {
  return {
    menuActive: "",
    hash: "",
  };
};

const state = getDefaultState();

const getters = {
  getMenuActive: (state, getter, rootState) => {
    return state.menuActive;
  },
  getHash: (state, getter, rootState) => {
    return state.hash;
  },
};

//commit 呼叫
const mutations = {
  setMenuActive(state, menuActive) {
    state.menuActive = menuActive;
  },

  setHash(state, hash) {
    state.hash = hash;
  },

  resetState(state) {
    const initState = getDefaultState();
    Object.keys(initState).forEach((key) => {
      state[key] = initState[key];
    });
  },
};

//用dispatch 呼叫
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
